import { render, staticRenderFns } from "./declareList - 副本.vue?vue&type=template&id=1734895a&scoped=true"
import script from "./declareList - 副本.vue?vue&type=script&lang=js"
export * from "./declareList - 副本.vue?vue&type=script&lang=js"
import style0 from "./declareList - 副本.vue?vue&type=style&index=0&id=1734895a&lang=less"
import style1 from "./declareList - 副本.vue?vue&type=style&index=1&id=1734895a&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1734895a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1734895a')) {
      api.createRecord('1734895a', component.options)
    } else {
      api.reload('1734895a', component.options)
    }
    module.hot.accept("./declareList - 副本.vue?vue&type=template&id=1734895a&scoped=true", function () {
      api.rerender('1734895a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/declareList - 副本.vue"
export default component.exports